var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 342 513",
    style: {
      enableBackground: "new 0 0 342 513"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#495162",
    d: "M302.5,354.1c-60.4-21.8-79.7-40.2-79.7-79.5c0-4.3,0.6-7.6,1.7-10.4c4.7-12.2,18.2-13.5,24.9-48.8 c3.4-18,19.7-0.3,22.8-41.3c0-16.3-8.9-20.4-8.9-20.4s4.5-24.2,6.3-42.8c2.2-23.2-13.5-83.1-97.4-83.1c-0.4,0-0.7,0-1.1,0 c-0.4,0-0.7,0-1.1,0c-83.9,0-99.6,59.9-97.4,83.1c1.8,18.6,6.3,42.8,6.3,42.8s-8.9,4.1-8.9,20.4c3.1,41,19.4,23.3,22.8,41.3 c6.6,35.3,20.1,36.7,24.9,48.8c1.1,2.7,1.7,6,1.7,10.4c0,39.4-19.3,57.8-79.7,79.5c-15.2,5.5-28.2,11-39.3,16.4L0.1,513.1h170.8h0.3 h170.9l0.2-142.3C331.1,365.3,317.9,359.7,302.5,354.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.cbd7400407999287d822e02d2c7b5370.svg";
export { ForwardRef as ReactComponent };